import { render, staticRenderFns } from "./NovoUsuarioDialog.vue?vue&type=template&id=4b78b082&"
import script from "./NovoUsuarioDialog.vue?vue&type=script&lang=js&"
export * from "./NovoUsuarioDialog.vue?vue&type=script&lang=js&"
import style0 from "./NovoUsuarioDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports